const confirmViewFuturePaymentsReducer = (state = '', action) => {
	switch(action.type){
	case 'CONFIRMVIEWFUTUREPAYMENTSCHANGE':
		return action.payload;
	default:
		return state;
	}
}

export default confirmViewFuturePaymentsReducer;